<div class="stepper-body">
    <div class="body-title">
        <span>Are you interested in taking cash out?</span>
    </div>
    <div class="body-description">
        <span>You can change your mind at a later point, but this will help to customize the quotes you’ll see.</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(FirstLienOptions.Yes)
                        }" (click)="onAnswerSelected(FirstLienOptions.Yes)">
                {{FirstLienOptions.Yes}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(FirstLienOptions.No)
                        }" (click)="onAnswerSelected(FirstLienOptions.No)">
                {{FirstLienOptions.No}}
            </button>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary"
            (click)="onBack()" class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary" [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>